import { Component, ViewChild, inject, signal } from '@angular/core';
import { NotificationModalComponent } from 'app/features/notification/components/notification-modal/notification-modal.component';
import { NotificationStoreService } from 'app/core/services/notifications/store/notification-store.service';

@Component({
  selector: 'notification-bell',
  standalone: true,
  imports: [NotificationModalComponent],
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.css',
})
export class NotificationBellComponent {
  private readonly notifStore = inject(NotificationStoreService);

  readonly notificationsOpen = signal(false);
  @ViewChild(NotificationModalComponent) notificationModal!: NotificationModalComponent;

  readonly unreadCount = this.notifStore.unreadCount;

  constructor() {
    this.notifStore.init();
  }

  toggleNotifications(ev: MouseEvent) {
    if (this.notificationsOpen()) {
      this.notificationsOpen.set(false);
      return;
    }

    this.notifStore.unreadCount.set(0);
    this.notificationModal.openFromClick(ev);
  }

  onNotificationsClosed() {
    this.notifStore.refreshUnread();
  }
}
